import { render, staticRenderFns } from "./ChangeEmail.vue?vue&type=template&id=63e1aeaa&scoped=true"
import script from "./ChangeEmail.vue?vue&type=script&lang=js"
export * from "./ChangeEmail.vue?vue&type=script&lang=js"
import style0 from "./ChangeEmail.vue?vue&type=style&index=0&id=63e1aeaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e1aeaa",
  null
  
)

export default component.exports